module.exports = __webpack_public_path__ + "img/categorie-nos-points-de-vente-famille-boutrais-big.649f3e44.jpg";